import React, { useContext } from 'react';
import { withSkeleton } from '../../../../AppTable/helpers/withSkeleton';
import { AppTableContext } from '../../../../AppTable/AppTableContext';

import { WMSkeleton, WMSkeletonProps } from '@walkme/wm-ui';
import { BY_SEGMENTS } from '../../models/consts';
import { useAudiencesLists } from '../../../../Audiences/hooks/hooks';
import { AudienceOption } from '../../../../../helpers/audiences';
import { Notification } from '../../../../../models';
import { AudiencesCellItem } from './AudiencesCellItem/AudiencesCellItem';
import classes from './AudiencesCell.module.scss';
import clsx from 'clsx';
import { useSelector } from '../../../../../infrastructure/store.interface';
import { FeatureFlagKeys, hasRequiredPermissions, CC_PERMISSIONS } from '@communication-center/data-objects';
import { useFeatureFlag } from '../../../../AppPreloading/hooks/settings/useUserSettings';

const audienceSkeletonOptions: WMSkeletonProps = { height: 12, width: 90, variant: 'text' };

export type NotificationFullAudiences = { audiences: AudienceOption[] } & Notification;

const AudiencesCell = ({ rowData: notification }: { rowData: NotificationFullAudiences }) => {
    const { tableDataTestid } = useContext(AppTableContext);
    const { audiencesList } = useAudiencesLists();
    const audiencesListInitialized = !!audiencesList;
    const emptyState = !notification.audiencesIds?.length || (audiencesListInitialized && !notification.audiences?.length);
    const bySegments = emptyState && !!notification.targetAudience?.length;
    const audiences = notification.audiences?.sort((a, b) => a.value.localeCompare(b.value));
    const user = useSelector(state => state.common.user);
    const permissionsFF = useFeatureFlag(FeatureFlagKeys.Permissions);
    const disablePointer = permissionsFF && !hasRequiredPermissions(user, [CC_PERMISSIONS.Audiences]);
    return (
        <div
            data-testid={`${notification.id}-audience-${tableDataTestid}`}
            onClick={e => e.stopPropagation()}
            className={clsx(classes.AudienceCell, { [classes.disablePointer]: disablePointer })}
        >
            <>
                {bySegments ? (
                    <span>{BY_SEGMENTS}</span>
                ) : audiencesListInitialized ? (
                    <AudiencesCellItem
                        audiences={audiences}
                        endUsersIds={notification.endUsersIds}
                        totalRecipients={notification.activeRecipientsNum!}
                        notificationName={notification.title!}
                        notificationId={notification.id!}
                    />
                ) : (
                    <WMSkeleton animation="wave" {...audienceSkeletonOptions} />
                )}
            </>
        </div>
    );
};

export default withSkeleton(audienceSkeletonOptions)(AudiencesCell);
